module.exports = __webpack_public_path__ + "img/5.84d95974.jpg";